import React from "react";
import { Colours } from "@learningblocks/shared-components";
import ContentLoader from "react-content-loader";
import cname from "../WidgetStyles";

export default function ControlBlockLoader() {
  return (
    <ContentLoader
      className={cname.loader}
      speed={2}
      backgroundColor={Colours.colorPrimary}
      foregroundColor="#3997dc"
    >
      <rect x="2" y="0" rx="3" ry="3" width="1000" height="100" />
    </ContentLoader>
  );
}

ControlBlockLoader.propTypes = {};

ControlBlockLoader.defaultProps = {};
